import SanitizedText from 'sanitize-text/components/SanitizedText';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { UserIcon } from 'foundations-assets/icons/components/UserIcon';
import { Timestamp } from './Timestamp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AccessGrantMessage = ({
  message
}) => {
  const body = message.richText || message.text;
  if (!body) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    gap: "400",
    "data-test-id": "thread-access-grant-message",
    children: [/*#__PURE__*/_jsx(Flex, {
      flex: "1",
      minInlineSize: "40px",
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderColor: "border-core-subtle"
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "200",
      paddingBlock: "100",
      paddingInline: "300",
      borderRadius: "full",
      borderWidth: "100",
      borderStyle: "solid",
      borderColor: "border-core-subtle",
      maxInlineSize: "100%",
      children: [/*#__PURE__*/_jsx(UserIcon, {
        size: "200",
        color: "icon-core-subtle"
      }), /*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "detail-200",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(SanitizedText, {
          body: body,
          formattingOptions: {
            shouldPreventAutoLinker: true
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        color: "text-core-subtle",
        whiteSpace: "nowrap",
        children: /*#__PURE__*/_jsx(Timestamp, {
          timestamp: message.timestamp
        })
      })]
    }), /*#__PURE__*/_jsx(Flex, {
      flex: "1",
      minInlineSize: "40px",
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderColor: "border-core-subtle"
    })]
  });
};